import React, { CSSProperties } from 'react';

import { ErrorMessage, FieldProps } from 'formik';

import { styled } from '../theme';
import FieldStatusText from './FieldStatusText';
import FlexRow from './FlexRow';
import FormGroup from './FormGroup';
import Toggle from './Toggle';

const Container = styled(FlexRow)(({ theme }) => ({
    paddingTop: 15,
    cursor: 'pointer',
}));

const FieldError: React.FC<React.PropsWithChildren> = ({ children }) => (
    <FieldStatusText status="error">{children}</FieldStatusText>
);

type Props = {
    name: string;
    mapNameToLabel: (name: string) => string;
    value: boolean;
    onChange: (value: boolean) => void;
    autoFocus?: boolean;
    componentStyle?: CSSProperties;
};

const FormikToggle: React.FC<Props & FieldProps<any>> = ({
    field,
    form,
    mapNameToLabel,
    componentStyle,
    ...props
}) => (
    <FormGroup>
        <Container
            align="center"
            style={componentStyle}
            onClick={() => {
                form.setTouched({ ...form.touched, [field.name]: true });
                form.setValues({ ...form.values, [field.name]: !field.value });
            }}
        >
            <Toggle style={{ pointerEvents: 'none' }} checked={field.value} readOnly />
            <span>{mapNameToLabel(field.name)}</span>
        </Container>
        <ErrorMessage name={field.name} component={FieldError} />
    </FormGroup>
);

export default FormikToggle;
